import React from "react";
import { cleanPhone } from "../../functions/cleanPhone";

const StringInput = ({
  value,
  onChange,
  placeholder = "Enter value",
  onKeyPress,
  autoFocus = false,
  filterType = null,
  maxLength = null,
}) => {
  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (filterType === "phone") {
      const cleanedValue = cleanPhone(inputValue);
      onChange(cleanedValue);
    } else {
      onChange(inputValue);
    }
  };

  return (
    <input
      type="text"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      className="px-3 py-1 border-0.5 border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-pink focus:border-transparent min-w-[120px]"
      onKeyPress={onKeyPress}
      autoFocus={autoFocus}
      maxLength={maxLength}
    />
  );
};

export default StringInput;
